export const Field = ({ id, label, hint, error, children }) => (
  <div className="mb-4">
    <label htmlFor={id} className="ts-label">{label}</label>
    {children}
    {hint && !error && <p className="text-xs mt-1.5" style={{ color: "var(--muted-text)" }}>{hint}</p>}
    {error && <p className="ts-error mt-1.5" role="alert" data-testid={`${id}-error`}>{error}</p>}
  </div>
);

export const FormError = ({ message, testId = "form-error" }) =>
  message ? (
    <div role="alert" data-testid={testId} className="text-sm rounded px-3 py-2 mb-4" style={{ background: "var(--red-soft)", color: "var(--red)" }}>
      {message}
    </div>
  ) : null;

export const FormSuccess = ({ message, testId = "form-success" }) =>
  message ? (
    <div role="status" data-testid={testId} className="text-sm rounded px-3 py-2 mb-4" style={{ background: "var(--blue-soft)", color: "var(--blue-deep)" }}>
      {message}
    </div>
  ) : null;
